"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentMoveApi = attachmentMoveApi;
exports.fileDeleteApi = fileDeleteApi;
exports.fileFileApi = fileFileApi;
exports.fileImageApi = fileImageApi;
exports.fileListApi = fileListApi;
exports.getPrintContentApi = getPrintContentApi;
exports.mediadomainApi = mediadomainApi;
exports.merchantAddressDeleteApi = merchantAddressDeleteApi;
exports.merchantAddressListApi = merchantAddressListApi;
exports.merchantAddressSaveApi = merchantAddressSaveApi;
exports.merchantAddressSetDefaultApi = merchantAddressSetDefaultApi;
exports.merchantAddressUpdateApi = merchantAddressUpdateApi;
exports.merchantAddressUpdateShowApi = merchantAddressUpdateShowApi;
exports.merchantElectrSheetAdd = merchantElectrSheetAdd;
exports.merchantElectrSheetDelete = merchantElectrSheetDelete;
exports.merchantElectrSheetEdit = merchantElectrSheetEdit;
exports.merchantElectrSheetInfo = merchantElectrSheetInfo;
exports.merchantPrintDelete = merchantPrintDelete;
exports.merchantPrintEdit = merchantPrintEdit;
exports.merchantPrintInfo = merchantPrintInfo;
exports.merchantPrintList = merchantPrintList;
exports.merchantPrintSave = merchantPrintSave;
exports.merchantPrintStatus = merchantPrintStatus;
exports.savePrintContentApi = savePrintContentApi;
exports.systemConfigCheck = systemConfigCheck;
exports.systemConfigInfo = systemConfigInfo;
exports.systemConfigSave = systemConfigSave;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function systemConfigCheck(pram) {
  var data = {
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/system/config/check',
    method: 'GET',
    params: data
  });
}
function systemConfigInfo(pram) {
  var data = {
    formId: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/config/info',
    method: 'GET',
    params: data
  });
}
function systemConfigSave(pram) {
  return (0, _request.default)({
    url: '/admin/system/config/save/form',
    method: 'POST',
    data: pram
  });
}

/**
 * 文件上传
 * @param data
 */
function fileFileApi(data, params) {
  return (0, _request.default)({
    url: '/admin/merchant/upload/file',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片上传
 * @param data
 */
function fileImageApi(data, params) {
  return (0, _request.default)({
    url: '/admin/merchant/upload/image',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片列表
 * @param data
 */
function fileListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/attachment/list',
    method: 'get',
    params: params
  });
}

/**
 * 图片列表 删除图片
 * @param data
 */
function fileDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/attachment/delete",
    method: 'post',
    data: {
      ids: id
    }
  });
}

/**
 * 图片列表 移動分類
 * @param data
 */
function attachmentMoveApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/attachment/move",
    method: 'post',
    data: data
  });
}

/**
 *  商家小票打印配置列表
 * @param pram
 * @returns {*}
 */
function merchantPrintList(pram) {
  return (0, _request.default)({
    url: '/admin/merchant/print/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 商家小票打印配置删除
 * @param id
 * @returns {*}
 */
function merchantPrintDelete(id) {
  return (0, _request.default)({
    url: '/admin/merchant/print/delete/' + id,
    method: 'GET'
  });
}

/**
 * 商家小票打印配置详情
 * @param pram
 * @returns {*}
 */
function merchantPrintInfo(pram) {
  var data = {
    key: pram.key
  };
  return (0, _request.default)({
    url: '/admin/merchant/print/info/{id}',
    method: 'GET',
    params: data
  });
}

/**
 * 商家小票打印配置新增
 * @param data
 * @returns {*}
 */
function merchantPrintSave(data) {
  return (0, _request.default)({
    url: "/admin/merchant/print/save",
    method: 'post',
    data: data
  });
}

/**
 * 商家小票打印配置更新状态
 * @param data
 * @returns {*}
 */
function merchantPrintStatus(data) {
  return (0, _request.default)({
    url: "/admin/merchant/print/status",
    method: 'post',
    data: data
  });
}

/**
 * 商家小票打印配置编辑
 * @param data
 * @returns {*}
 */
function merchantPrintEdit(data) {
  return (0, _request.default)({
    url: "/admin/merchant/print/update",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单编辑
 * @param data
 * @returns {*}
 */
function merchantElectrSheetEdit(data) {
  return (0, _request.default)({
    url: "/admin/merchant/elect/update",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单新增
 * @param data
 * @returns {*}
 */
function merchantElectrSheetAdd(data) {
  return (0, _request.default)({
    url: "/admin/merchant/elect/save",
    method: 'post',
    data: data
  });
}

/**
 * 商家电子面单详情
 * @returns {*}
 */
function merchantElectrSheetInfo() {
  return (0, _request.default)({
    url: "/admin/merchant/elect/info",
    method: 'get'
  });
}

/**
 * 商家电子面单删除
 * @param id
 * @returns {*}
 */
function merchantElectrSheetDelete(id) {
  return (0, _request.default)({
    url: "/admin/merchant/elect/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商户地址分页列表
 * @param data
 * @returns {*}
 */
function merchantAddressListApi() {
  return (0, _request.default)({
    url: "/admin/merchant/address/list",
    method: 'get'
  });
}

/**
 * 删除商户地址
 * @param data
 * @returns {*}
 */
function merchantAddressDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/address/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 新增商户地址
 * @param data
 * @returns {*}
 */
function merchantAddressSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/address/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改商户地址
 * @param data
 * @returns {*}
 */
function merchantAddressUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/address/update",
    method: 'post',
    data: data
  });
}

/**
 * 设置商户默认地址
 * @param data
 * @returns {*}
 */
function merchantAddressSetDefaultApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/address/set/default/".concat(id),
    method: 'post'
  });
}

/**
 * 设置商户地址开启状态
 * @param data
 * @returns {*}
 */
function merchantAddressUpdateShowApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/address/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 获取平台当前的素材地址
 */
function mediadomainApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/admin/mediadomain',
    method: 'get'
  });
}

/**
 * 获取打印内容配置
 */
function getPrintContentApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/print/get/content/".concat(id),
    method: 'get'
  });
}

/**
 * 保存打印内容配置
 */
function savePrintContentApi(data, id) {
  return (0, _request.default)({
    url: "/admin/merchant/print/save/content/".concat(id),
    method: 'post',
    data: data
  });
}